module.exports = __webpack_public_path__ + "img/analysis-deposit.db41273f.svg";